import { render, staticRenderFns } from "./TestAppIo.vue?vue&type=template&id=945b4e38"
import script from "./TestAppIo.vue?vue&type=script&lang=js"
export * from "./TestAppIo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports